import React from 'react';
import styled from 'styled-components';
import { PortWidget, PortModelAlignment, NodeModel, DiagramEngine } from '@projectstorm/react-diagrams';

interface PortsProps {
  node: NodeModel;
  engine: DiagramEngine;
  width: number;
  height: number;
}

export const Ports = ({ node, engine, width, height }: PortsProps) => {
  return (
    <>
      <PortWidget
        engine={engine}
        port={node.getPort(PortModelAlignment.LEFT)}
        style={{
          top: Math.ceil(height / 2),
          left: 0,
          position: 'absolute',
        }}
      >
        <div className="left-port" />
        <PortStyle />
      </PortWidget>
      <PortWidget
        engine={engine}
        port={node.getPort(PortModelAlignment.TOP)}
        style={{
          top: 0,
          left: Math.ceil(width / 2),
          position: 'absolute',
        }}
      >
        <div className="top-port" />
        <PortStyle />
      </PortWidget>
      <PortWidget
        engine={engine}
        port={node.getPort(PortModelAlignment.RIGHT)}
        style={{
          top: Math.ceil(height / 2),
          left: width - 1,
          position: 'absolute',
        }}
      >
        <div className="right-port" />
        <PortStyle />
      </PortWidget>
      <PortWidget
        engine={engine}
        port={node.getPort(PortModelAlignment.BOTTOM)}
        style={{
          top: height,
          left: Math.ceil(width / 2),
          position: 'absolute',
        }}
      >
        <div className="bottom-port" />
        <PortStyle />
      </PortWidget>
    </>
  );
};

const PortStyle = styled.div`
  width: 1px;
  height: 1px;
  z-index: 10;
  background: rgba(0, 0, 0, 0);
  border-radius: 1px;
  cursor: pointer;

  &:hover {
    background: rgba(0, 0, 0, 0);
  }
`;
